export const AddressApi = {
    GET_PROVINCES: '/provinces',
    GET_DISTRICTS: '/districts',
    GET_WARDS: '/wards',
  };